module.exports = __webpack_public_path__ + "static/media/10Demo Photo-ink-min.1999942e.jpeg";